<template>
  <div class="text-center">
    <v-dialog
      v-model="dialog"
      width="300"
    >
      <template v-slot:activator="{ on, attrs }">
      <v-list-item  v-bind="attrs" v-on="on">
        <v-list-item-icon class="iconX">
             <v-img max-height='30' max-width='25' :src="require('../assets/wlogout.png')" contain></v-img>
               <v-list-item-title class="log">Logout</v-list-item-title> 
        </v-list-item-icon>
      </v-list-item>
      </template>

      <v-card>
        <v-card-title class="headline white">
        Confirm Logout
        </v-card-title>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
          block
          dark
          color="pink"
          @click="navigate()"
          >
           Logout
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
  export default {
    data () {
      return {
        dialog: false,
      }
    },
     methods: {
      navigate(){
        this.dialog=false
         this.$store.commit('setUser', null)
        this.$router.push({name: 'login'})
      },
     }
  }
</script>
<style scoped>
.iconX{
  display: flex;
}
.log{
  margin-left: 20px;
}
</style>